import React from 'react';
import dayjs from 'dayjs';
import { Space } from 'components/barbr';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { isEmpty } from '_dash';
import { getScheduleItem } from 'utils';

import './style.scss';

dayjs.extend(customParseFormat);

const ProfileSchedule = ({ schedules = [] }) => {
  const todayDay = dayjs().format('dddd');

  return Array(7)
    .fill(0)
    .map((_, i) => {
      const day = dayjs()
        .day(i + 1)
        .format('dddd');
      const schedule = schedules.find((item) => item.day_of_week === day);
      return (
        <Space key={day} className={`${day === todayDay ? 'today' : ''}`} justify='space-between barber-profile-schedule-item'>
          <p>{day}</p>
          <p>
            <Choose>
              <When condition={isEmpty(schedule)}>Closed</When>
              <Otherwise>{getScheduleItem(schedule)}</Otherwise>
            </Choose>
          </p>
        </Space>
      );
    });
};

export default React.memo(ProfileSchedule);
